import _get from "lodash/get";
import { ENTER_KEY } from './keyCode';
function isEnterPress(e) {
  return _get(e, 'key') === ENTER_KEY ? true : false;
}
export default isEnterPress;